import { Injectable } from '@angular/core';
import {
  Bloc,
  ErrorState,
  ProcessingState,
} from 'src/app/shared/bloc/base-bloc';
import { HeaderEvent, HeaderLogOutEvent } from './header-events';
import { HeaderLoggedOutState, HeaderState } from './header-states';
import { AuthenticationRepository } from '../../../../core/data/repository/authentication-repository';
import { takeUntil } from 'rxjs';
import { NonDrawing } from 'src/app/shared/model';
import { NotificationsRepository } from 'src/app/core/data/repository/notifications-repository';
@Injectable()
export class HeaderBloc extends Bloc<HeaderEvent, HeaderState> {
  constructor(private authenticationRepository: AuthenticationRepository,  private notificationsRepository: NotificationsRepository) {
    super();
  }
  onIncomingEvents(event: HeaderEvent): void {
    // start logout event
    if (event instanceof HeaderLogOutEvent) {
      // fake loading
      this.onState$.next(new ProcessingState<NonDrawing>(new NonDrawing()));
      // call repository
      this.authenticationRepository
        .logout()
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res) => {
            this.onState$.next(new HeaderLoggedOutState());
          },
          error: (error) => {
            new ErrorState<NonDrawing>(new NonDrawing(), error);
          },
        });
    }
  }
}
